import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import Modifiers from "../models/Modifiers";

export default class OtherHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "init":
                return this.handleInit(model, params);
            case "display":
                return this.handleDisplay(model, params);
            case "expand":
                return this.handleExpand(model, params);
            case "collapse":
                return this.handleCollapse(model, params);
            case "comment/expand":
                return this.handleCommentExpand(model, params);
            default:
                return model;
        }
    }

    private handleCommentExpand(model: DiscussionModel, comment: number): DiscussionModel {
        model = Modifiers.expandComment(model, comment);
        return model;
    }

    private handleExpand(model: DiscussionModel, comment: number): DiscussionModel {
        model = Modifiers.expandChildren(model, comment);
        return model;
    }

    private handleCollapse(model: DiscussionModel, comment: number): DiscussionModel {
        model = Modifiers.collapseChildren(model, comment);
        return model;
    }

    private handleInit(model: DiscussionModel, params?: any): DiscussionModel {

        if (location.hash == "#diskusia") {
            this.dispatch("display", {display: true, autofocus: true});
        }

        return model;

    }

    private handleDisplay(model: DiscussionModel, params: {display: boolean, autofocus: boolean}): DiscussionModel {

        if (params.display && model.getComments().isEmpty()) {
            this.dispatch("load/start");
        }

        model = model.setAutofocus(params.autofocus);
        model = model.setDisplay(params.display);
        return model;

    }

}